import Settings from '@mui/icons-material/Settings'
import { Avatar } from '@mui/material'
import { ActionBarItem } from '@workwave-tidal/core/components/ActionBar'
import { Close } from '@workwave-tidal/core/icons'
import { useSelector } from 'react-redux'

import { ModalHeader } from '@/components/Modal'
import { selectCalendarRangeInterval } from '@/features/domain/ui'
import { useFormatDateInterval } from '@/hooks'

import { useController } from '../hooks/useController'
import { useTexts } from '../useTexts'

export function Header() {
  const texts = useTexts()
  const { close } = useController()
  const { start, end } = useSelector(selectCalendarRangeInterval)

  const interval = useFormatDateInterval(start, end, false, true)

  const isMultiDay = start.getTime() !== end.getTime()
  const title = isMultiDay ? texts.titleWithRange(interval) : texts.title

  return (
    <ModalHeader
      avatar={
        <Avatar
          sx={{
            bgcolor: t => t.vars.palette.action.hover,
            color: t => t.vars.palette.action.active,
            width: 32,
            height: 32,
          }}
        >
          <Settings sx={{ fontSize: 18 }} />
        </Avatar>
      }
      title={title}
      actions={[
        <ActionBarItem
          icon={<Close />}
          testId="close-button"
          key="close"
          onClick={close}
          label=""
        />,
      ]}
    />
  )
}
